import React, { useState, useEffect } from 'react';
interface BarcodeScannerProps {
  setBarcodeDetails: (details: string) => void;
  barcodeDetails: string | null;
}
const BarcodeScanner: React.FC<BarcodeScannerProps> = ({
  setBarcodeDetails,
}) => {
  const [inputBuffer, setInputBuffer] = useState('');
  const [lastScanTime, setLastScanTime] = useState(0);
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      const currentTime = new Date().getTime();
      if (currentTime - lastScanTime > 100) {
        setInputBuffer(event.key);
      } else {
        setInputBuffer((prevBuffer) => prevBuffer + event.key);
      }
      setLastScanTime(currentTime);
      if (event.key === 'Enter') {
        event.preventDefault();
        setBarcodeDetails(inputBuffer);
        setInputBuffer('');
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [lastScanTime, inputBuffer, setBarcodeDetails]);
  return (
    <div className="flex h-[220px] w-[468px] flex-col items-center justify-center gap-[10px] rounded-3xl bg-white shadow-custom xl:h-[278px]">
      <svg
        width="38"
        height="39"
        viewBox="0 0 38 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28 0.73999H1C0.44775 0.73999 0 1.18774 0 1.73999V13.74C0 13.758 0.00934009 13.773 0.0102501 13.7908C0.0110401 13.8074 0.00322995 13.8229 0.00487995 13.8396L1.91595 32.9504C0.79755 33.3867 0 34.4689 0 35.74C0 37.3943 1.3457 38.74 3 38.74H14C15.6543 38.74 17 37.3943 17 35.74C17 34.3568 16.0543 33.201 14.7789 32.8555L12.4639 25.1399C12.2293 24.3572 12.0842 23.5529 12.0278 22.74H18C18.5522 22.74 19 22.2922 19 21.74V18.971C19 18.2356 19.0903 17.5012 19.2686 16.7883L19.7808 14.74H26C26.4888 14.74 26.9062 14.3865 26.9863 13.9045L28.9863 1.90454C29.0347 1.6145 28.9531 1.31811 28.7632 1.0935C28.5732 0.86938 28.2939 0.73999 28 0.73999ZM26.8193 2.73999L26.486 4.73999H2V2.73999H26.8193ZM14 36.74H3C2.44873 36.74 2 36.2913 2 35.74C2 35.1887 2.44873 34.74 3 34.74H14C14.5513 34.74 15 35.1887 15 35.74C15 36.2913 14.5513 36.74 14 36.74ZM12.6558 32.74H3.90479L2.10499 14.74H10V21.74V21.9788C10 23.2449 10.1846 24.5017 10.5478 25.7146L12.6558 32.74ZM17.3281 16.3035C17.1103 17.1751 17 18.0725 17 18.971V20.74H12V14.74H17.7192L17.3281 16.3035ZM25.1528 12.74H19H11H2V6.73999H26.1527L25.1528 12.74Z"
          fill="#374151"
        />
        <path
          d="M5 10.74C5.55228 10.74 6 10.2923 6 9.73999C6 9.18771 5.55228 8.73999 5 8.73999C4.44772 8.73999 4 9.18771 4 9.73999C4 10.2923 4.44772 10.74 5 10.74Z"
          fill="#374151"
        />
        <path
          d="M9 10.74C9.55228 10.74 10 10.2923 10 9.73999C10 9.18771 9.55228 8.73999 9 8.73999C8.44772 8.73999 8 9.18771 8 9.73999C8 10.2923 8.44772 10.74 9 10.74Z"
          fill="#374151"
        />
        <path
          d="M13 10.74C13.5523 10.74 14 10.2923 14 9.73999C14 9.18771 13.5523 8.73999 13 8.73999C12.4477 8.73999 12 9.18771 12 9.73999C12 10.2923 12.4477 10.74 13 10.74Z"
          fill="#374151"
        />
        <path
          d="M37 6.73999H33C32.4477 6.73999 32 7.18774 32 7.73999C32 8.29224 32.4477 8.73999 33 8.73999H37C37.5522 8.73999 38 8.29224 38 7.73999C38 7.18774 37.5522 6.73999 37 6.73999Z"
          fill="#374151"
        />
        <path
          d="M32.8281 9.15405C32.4375 8.76343 31.8047 8.76343 31.4141 9.15405C31.0234 9.54467 31.0234 10.1775 31.4141 10.5681L34.2427 13.3967C34.438 13.592 34.6938 13.6897 34.9497 13.6897C35.2056 13.6897 35.4614 13.592 35.6567 13.3967C36.0474 13.0061 36.0474 12.3733 35.6567 11.9827L32.8281 9.15405Z"
          fill="#374151"
        />
        <path
          d="M32.1211 6.61889C32.377 6.61889 32.6328 6.52123 32.8281 6.32592L35.6567 3.49731C36.0474 3.10669 36.0474 2.47387 35.6567 2.08325C35.2661 1.69263 34.6333 1.69263 34.2427 2.08325L31.4141 4.91186C31.0234 5.30248 31.0234 5.9353 31.4141 6.32592C31.6094 6.52123 31.8652 6.61889 32.1211 6.61889Z"
          fill="#374151"
        />
      </svg>

      <div className="text-center text-lg font-medium leading-[27px]">
        Start Scanning
      </div>
    </div>
  );
};
export default BarcodeScanner;
